import { createHead } from '@vueuse/head';

export default function install(app) {
  const head = createHead();
  app.use(head);
}
